  <template>
  <v-container>
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
      style="padding-left: 16px; padding-bottom: 0px; padding-top: 0px"
    >
      <div>Izbor redova</div>

      <button
        id="closeModalBtn"
        @click.prevent="closeModalInModal_izbor_redova"
        class="v-btn v-btn--flat white"
      >
        <v-icon>close</v-icon>
      </button>
    </div>

    <div data-v-fae5bece class="spacer"></div>

    <v-form ref="form1" v-model="valid" lazy-validation>
      <v-layout row>
        <v-flex xs6 pa-2>
          <v-autocomplete
            v-model="vinery_block_select"
            :items="vinery_block_items"
            item-text="name"
            item-value="id"
            label="Parcele"
            persistent-hint
            return-object
            ref="element1"
            multiple
            chips
            deletable-chips
            hide-no-data
            clearable
            v-on:change="getAllGrapeVariety"
            v-if="vinery_block_items.length > 0"
            :disabled="izmena"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 pa-2>
          <v-autocomplete
            v-model="vinery_table_select"
            :items="vinery_table_items"
            item-text="name"
            item-value="id"
            label="Table"
            persistent-hint
            return-object
            ref="element11"
            multiple
            chips
            deletable-chips
            hide-no-data
            clearable
            v-on:change="changeTabla"
            v-if="vinery_block_items.length > 0"
            :disabled="izmena"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="grape_variety_select"
            :items="grape_variety_items"
            item-text="name"
            item-value="id"
            label="Sorta"
            persistent-hint
            return-object
            ref="element2"
            hide-no-data
            :clearable="!izmena"
            v-on:change="changeGrapeVariety"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="izmena"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 pa-2 style="width: 55% !important">
          <v-text-field
            v-model="kolicina"
            label="Ubrana količina"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            min="0"
            :disabled="!izmena_init"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_grozdja_select"
            :items="jm_items"
            item-text="mark"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            :disabled="!izmena_init"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="secer"
            label="Šećer"
            type="number"
            min="0"
            suffix="°Oe"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="kiselina"
            label="Kiselina"
            type="number"
            min="0"
            suffix="g/l"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs10 pa-2>
          <v-text-field
            v-model="opis"
            label="Opis"
            :disabled="izmena"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-checkbox
            id="makarije"
            label="Prikaži filtere"
            v-model="prikazi"
            :checked="prikazi"
            v-on:change="sakriFiltere"
            :disabled="izmena"
          ></v-checkbox>
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="form" v-model="valid" lazy-validation>
      <Transition>
        <div v-show="prikazi">
          <fieldset
            style="
              border-color: #018389;
              border-style: solid !important;
              padding-left: 15px;
              margin-bottom: 15px;
            "
          >
            <legend style="padding-left: 5px; padding-right: 5px">
              Izbor {{ tekstBiljka }} na više redova
            </legend>
            <v-layout row style="padding-left: 0px">
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="odReda"
                  label="Od reda"
                  type="number"
                  ref="element3"
                  :disabled="izmena"
                  :min="minOdReda"
                  :max="maxOdReda"
                  v-on:change="OdReda"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="doReda"
                  label="Do reda"
                  type="number"
                  ref="element4"
                  :disabled="izmena"
                  :min="minDoReda"
                  :max="maxDoReda"
                  v-on:change="DoReda"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="odCokota"
                  :label="tekstBiljka4"
                  type="number"
                  ref="element5"
                  :disabled="izmena"
                  :min="minOdCokota"
                  :max="maxOdCokota"
                  v-on:change="OdCokota"
                ></v-text-field>
              </v-flex>
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="doCokota"
                  :label=this.tekstBiljka5
                  type="number"
                  ref="element6"
                  :disabled="izmena"
                  :min="minDoCokota"
                  :max="maxDoCokota"
                  v-on:change="DoCokota"
                ></v-text-field>
              </v-flex>
              <v-flex xs2 pa-2>
                <v-autocomplete
                  v-model="par_nepar_select"
                  :items="par_nepar_items"
                  item-text="name"
                  item-value="id"
                  label="Par/nepar"
                  persistent-hint
                  return-object
                  ref="element7"
                  deletable-chips
                  hide-no-data
                  clearable
                  :disabled="izmena"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 pa-2 style="margin-top: 10px">
                <v-btn
                  :disabled="!valid || !izmena || ucitavanje"
                  @click="submit"
                  class="AppButtonFilled"
                  >Primeni</v-btn
                >
                <!-- <v-btn
                    @click="odustani"
                    class="AppButtonOutlined"
                    :disabled="!izmena"
                    v-if="izmena"
                    >poništi</v-btn
                  >
                  <v-btn
                    @click="odustani"
                    class="AppButtonOutlined"
                    :disabled="!izmena"
                    v-else
                    style="border: none !important"
                    >odustani</v-btn
                  > -->
              </v-flex>
            </v-layout>
          </fieldset>
        </div>
      </Transition>
    </v-form>
    <v-layout column v-bind:style="{ height: visina + 'px' }">
      <v-flex
        style="overflow: auto"
        v-bind:style="{ 'max-height': visinaFlexa + 'px' }"
      >
        <v-data-table
          item-key="rowId"
          v-model="selected_izabrani_redovi"
          :headers="headers_modal_izabrani_redovi"
          :items="items_modal_izabrani_redovi"
          show-select
          hide-actions
          dense
          :pagination.sync="pagination"
          :search="search"
          expand
          fixed-header
          select-all
          ref="dTable"
        >
          <template slot="headers" slot-scope="props_modal">
            <tr style="text-align: center; padding: 5px">
              <!-- <th>
                  
                </th> -->
              <th style="text-align: center; padding: 5px">
                <div style="margin: 0 auto; width: 66px; text-align: center">
                  <table>
                    <tr>
                      <td style="padding: 0px">
                        <v-btn
                          v-if="!expanded_rows"
                          @click="toggleAll"
                          class="AppButtonFilled"
                          style="min-width: 10px; width: 10px; height: 20px"
                          color="teal"
                          >+</v-btn
                        >
                        <v-btn
                          v-else
                          @click="toggleAll"
                          class="AppButtonFilled"
                          style="min-width: 10px; width: 10px; height: 20px"
                          color="teal"
                          >-</v-btn
                        >
                      </td>
                      <td style="padding: 0px">
                        <!-- :disabled="!izmena" -->
                        <v-checkbox
                          primary
                          hide-details
                          @click.stop="toggleAll_izabrani_tankovi(props_modal)"
                          @keyup.space.prevent="
                            toggleAll_izabrani_tankovi(props_modal)
                          "
                          :input-value="props_modal.all"
                          :indeterminate="props_modal.indeterminate"
                          color="teal"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </table>
                </div>
              </th>
              <th
                :style="[
                  'text-align: center' + header.width !== null
                    ? '; width: ' + header.width + 'px'
                    : '',
                ]"
                v-for="header in props_modal.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                  header.align === 'left' ? 'text-xs-left' : 'text-xs-center',
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small v-if="header.sortable !== false"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props_modal">
            <tr>
              <td
                style="
                  padding-top: 0px;
                  padding-bottom: 5px;
                  width: 30px;
                  padding-left: 50px;
                  padding-right: 0px;
                "
              >
                <!-- :disabled="!izmena" -->
                <v-checkbox
                  primary
                  hide-details
                  :input-value="props_modal.selected"
                  @click="changeSelect(props_modal, props_modal.selected)"
                  color="teal"
                  :indeterminate="props_modal.item.indeterminate"
                ></v-checkbox>
              </td>
              <td style="display: none">
                {{ props_modal.item.rowId }}
              </td>
              <td
                style="text-align: center !important"
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
              >
                {{ props_modal.item.rowNumber }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 0px;
                  width: 100px !important;
                "
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
                v-if="props_modal.item.block !== null"
              >
                <!-- {{ formatRedova(props_modal.item.block) }} -->
                {{ props_modal.item.block }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 0px;
                  width: 100px !important;
                "
                v-else
              >
                -
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 0px;
                  width: 100px !important;
                "
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
                v-if="props_modal.item.tables !== null"
              >
                {{ formatRedova(props_modal.item.tables) }}
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 0px;
                  width: 100px !important;
                "
                v-else
              >
                -
              </td>
              <td
                style="
                  text-align: center !important;
                  padding: 0px;
                  width: 330px !important;
                "
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
                v-if="props_modal.item.grapeVarieties.length !== null"
              >
                {{ formatRedova(props_modal.item.grapeVarieties) }}
              </td>
              <td style="text-align: center !important; padding: 0px" v-else>
                Prazan red
              </td>
              <td
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
              ></td>
              <td
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
              ></td>
              <td
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
              ></td>
              <td
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
              ></td>
              <td
                @click="
                  props_modal.expanded =
                    !props_modal.expanded &&
                    props_modal.item.positions.length > 0
                "
                style="
                  text-align: center !important;
                  padding: 0px;
                  width: 200px !important;
                  font-weight: bold;
                  -webkit-text-fill-color: rgb(1, 131, 137);
                "
              ></td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props_modal">
            <v-data-table
              item-key="id_pom"
              v-model="selected_izabrani_redovi_pom"
              :headers="headers_modal_izabrani_redovi_pom"
              :items="props_modal.item.positions"
              hide-actions
              class="elevation-1"
              show-select
              dense
            >
              <template slot="headers" slot-scope="props_modal_1">
                <tr style="height: 1px !important">
                  <th
                    style="text-align: center; padding: 5px"
                    v-for="header in props_modal_1.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props_modal_1">
                <tr class="custom-highlight-row">
                  <span></span>
                  <span></span>
                  <td style="width: 73px"></td>
                  <td
                    style="width: 30px; padding-left: 40px; padding-right: 0px"
                  >
                    <!-- :disabled="!izmena" -->
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props_modal_1.selected"
                      @click="
                        changeSelectItem(
                          props_modal_1,
                          props_modal_1.selected,
                          props_modal
                        )
                      "
                      color="teal"
                    ></v-checkbox>
                  </td>
                  <td style="text-align: center; width: 115px; padding: 0px">
                    <!-- <template v-if="props_modal_1.item.block !== null">
                          {{ props_modal_1.item.block }}
                        </template>
                        <template v-else>
                          {{ "-" }}
                        </template> -->
                  </td>
                  <td style="text-align: center; width: 95px; padding: 0px">
                    <template v-if="props_modal_1.item.table !== null">
                      {{ props_modal_1.item.table }}
                    </template>
                    <template v-else>
                      {{ "-" }}
                    </template>
                  </td>
                  <td style="text-align: center; width: 190px; padding: 0px">
                    <template v-if="props_modal_1.item.grapeVariety !== null">
                      {{ props_modal_1.item.grapeVariety }}
                    </template>
                    <template v-else>
                      {{ "-" }}
                    </template>
                  </td>
                  <td style="text-align: center; width: 102px; padding: 0px">
                    <template
                      v-if="props_modal_1.item.plantNumberFrom !== null"
                    >
                      {{ props_modal_1.item.plantNumberFrom }}
                    </template>
                    <template v-else>
                      {{ "-" }}
                    </template>
                  </td>

                  <td style="text-align: center; width: 102px; padding: 0px">
                    <template v-if="props_modal_1.item.plantNumberTo !== null">
                      {{ props_modal_1.item.plantNumberTo }}
                    </template>
                    <template v-else>
                      {{ "-" }}
                    </template>
                  </td>
                  <td
                    style="
                      text-align: center;
                      font-weight: bold;
                      font-size: larger;
                      -webkit-text-fill-color: #018389;
                      width: 117px;
                      padding-right: 0px;
                      padding-left: 50px;
                    "
                    v-if="izmena"
                  >
                    <v-edit-dialog
                      ref="editDialogFrom"
                      @save="saveFrom(props_modal_1, props_modal)"
                      @cancel="cancelFrom(props_modal_1)"
                      @open="openFrom(props_modal_1)"
                      @close="closeFrom(props_modal_1)"
                      large
                      cancel-text="OK"
                      save-text="Odustani"
                      v-if="
                        props_modal_1.item.executedNumberFrom !== undefined &&
                        props_modal_1.item.executedNumberFrom !== null
                      "
                    >
                      <template v-slot:input>
                        <v-text-field
                          slot="input"
                          label="Edit"
                          v-model="props_modal_1.item.executedNumberFrom"
                          v-bind:value="props_modal_1.item.executedNumberFrom"
                          single-line
                          type="number"
                          :ref="'kolicinaOd_' + props_modal_1.item.id_pom"
                          min="0"
                        ></v-text-field>
                      </template>
                      {{ props_modal_1.item.executedNumberFrom }}
                    </v-edit-dialog>
                    <v-edit-dialog
                      @save="saveFrom(props_modal_1)"
                      @cancel="cancelFrom(props_modal_1)"
                      @open="openFrom(props_modal_1)"
                      @close="closeFrom(props_modal_1)"
                      large
                      cancel-text="OK"
                      save-text="Odustani"
                      v-else
                    >
                      <template v-slot:input>
                        <v-text-field
                          slot="input"
                          label="Edit"
                          v-model="props_modal_1.item.executedNumberFrom"
                          v-bind:value="props_modal_1.item.executedNumberFrom"
                          single-line
                          type="number"
                          :ref="'kolicinaOd_' + props_modal_1.item.id_pom"
                          min="0"
                        ></v-text-field>
                      </template>
                      {{ "-" }}
                    </v-edit-dialog>
                  </td>
                  <td
                    style="
                      text-align: center;
                      font-weight: bold;
                      font-size: larger;
                      -webkit-text-fill-color: #018389;
                    "
                    v-else
                  >
                    <template
                      v-if="
                        props_modal_1.item.executedNumberFrom !== undefined &&
                        props_modal_1.item.executedNumberFrom !== null
                      "
                    >
                      {{ props_modal_1.item.executedNumberFrom }}
                    </template>
                    <template v-else>
                      {{ "-" }}
                    </template>
                  </td>
                  <td
                    style="
                      text-align: center;
                      font-weight: bold;
                      font-size: larger;
                      -webkit-text-fill-color: #018389;
                      width: 117px;
                      padding-right: 0px;
                      padding-left: 50px;
                    "
                    v-if="izmena"
                  >
                    <v-edit-dialog
                      @save="saveTo(props_modal_1, props_modal)"
                      @cancel="cancelTo(props_modal_1)"
                      @open="openTo(props_modal_1)"
                      @close="closeTo(props_modal_1)"
                      large
                      cancel-text="OK"
                      save-text="Odustani"
                      v-if="
                        props_modal_1.item.executedNumberTo !== undefined &&
                        props_modal_1.item.executedNumberTo !== null
                      "
                    >
                      <template v-slot:input>
                        <v-text-field
                          slot="input"
                          label="Edit"
                          v-model="props_modal_1.item.executedNumberTo"
                          v-bind:value="props_modal_1.item.executedNumberTo"
                          single-line
                          type="number"
                          :ref="'kolicinaDo_' + props_modal_1.item.id_pom"
                          min="0"
                        ></v-text-field>
                      </template>
                      {{ props_modal_1.item.executedNumberTo }}
                    </v-edit-dialog>
                    <v-edit-dialog
                      @save="saveTo(props_modal_1)"
                      @cancel="cancelTo(props_modal_1)"
                      @open="openTo(props_modal_1)"
                      @close="closeTo(props_modal_1)"
                      large
                      cancel-text="OK"
                      save-text="Odustani"
                      v-else
                    >
                      <template v-slot:input>
                        <v-text-field
                          slot="input"
                          label="Edit"
                          v-model="props_modal_1.item.executedNumberTo"
                          v-bind:value="props_modal_1.item.executedNumberTo"
                          single-line
                          type="number"
                          :ref="'kolicinaDo_' + props_modal_1.item.id_pom"
                          min="0"
                        ></v-text-field>
                      </template>
                      {{ "-" }}
                    </v-edit-dialog>
                  </td>
                  <td
                    style="
                      text-align: center;
                      font-weight: bold;
                      font-size: larger;
                      -webkit-text-fill-color: #018389;
                    "
                    v-else
                  >
                    <template
                      v-if="
                        props_modal_1.item.executedNumberTo !== undefined &&
                        props_modal_1.item.executedNumberTo !== null
                      "
                    >
                      {{ props_modal_1.item.executedNumberTo }}
                    </template>
                    <template v-else>
                      {{ "-" }}
                    </template>
                  </td>

                  <template v-if="props_modal_1.item.executedNumberTo !== null">
                    <td
                      style="
                        text-align: center;
                        font-weight: bold;
                        font-size: larger;
                        -webkit-text-fill-color: #018389;
                      "
                      v-if="props_modal_1.selected"
                    >
                      {{
                        props_modal_1.item.executedNumberTo -
                        props_modal_1.item.executedNumberFrom +
                        1
                      }}
                    </td>
                    <td style="text-align: center" v-else>
                      {{
                        props_modal_1.item.executedNumberTo -
                        props_modal_1.item.executedNumberFrom +
                        1
                      }}
                    </td>
                  </template>
                  <template v-else>
                    <td style="text-align: center">
                      {{ "-" }}
                    </td>
                  </template>
                </tr>
              </template>
            </v-data-table>
          </template>
          <template slot="no-data">
            <v-alert slot="no-results" :value="true" color="primary" icon="info"
              >Nema podataka.</v-alert
            >
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- <v-flex xs12 v-if="izmena_init">
          <v-btn @click="changeSifarnik" class="AppButtonFilled">Sačuvaj</v-btn>
          <v-btn @click="clearViseRedova" class="AppButtonOutlined"
            >odustani</v-btn
          >
        </v-flex> -->
      <v-flex xs8>
        <v-btn
          @click="changeSifarnik"
          class="AppButtonFilled"
          :disabled="!izmena_init"
          >Sačuvaj</v-btn
        >
        <v-btn
          @click="clearViseRedova"
          class="AppButtonOutlined"
          v-if="izmena_init"
          >odustani</v-btn
        >
        <v-btn
          @click="clearViseRedova"
          class="AppButtonOutlined"
          :disabled="!izmena_init"
          v-else
          style="border: none !important"
          >odustani</v-btn
        >
      </v-flex>
      <v-flex xs1 pa-2>
        <div class="div_prozorce" v-if="broj_sorti !== 0">
          <p class="gornji_text" v-html="broj_sorti"></p>
          <p class="donji_text" v-html="formatTekstaSorta2(broj_sorti)"></p>
        </div>
        <div class="div_prozorce" v-else>
          <p class="gornji_text">-</p>
          <p class="donji_text">sorti</p>
        </div>
      </v-flex>
      <v-flex xs1 pa-2>
        <div class="div_prozorce" v-if="broj_redova !== 0">
          <p class="gornji_text" v-html="broj_redova"></p>
          <p class="donji_text" v-html="formatTekstaRed2(broj_redova)"></p>
        </div>
        <div class="div_prozorce" v-else>
          <p class="gornji_text">-</p>
          <p class="donji_text">redova</p>
        </div>
      </v-flex>
      <v-flex xs1 pa-2>
        <div class="div_prozorce" v-if="broj_kalemova !== 0">
            <p class="gornji_text" v-html="broj_kalemova"></p>
            <p
              class="donji_text"
              v-html="formatTekstaKalem2(broj_kalemova)"
            ></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text"
            v-html="formatTekstaKalem2(0)"></p>
          </div>
      </v-flex>
      <v-flex xs1 pa-2>
        <template v-if="povrsina > 1000">
          <div class="div_prozorce" v-if="broj_sorti !== 0">
            <p
              class="gornji_text"
              v-html="Math.round(povrsina / 100) / 100"
            ></p>
            <p class="donji_text">ha</p>
          </div>
        </template>
        <template v-else-if="povrsina > 0">
          <div class="div_prozorce" v-if="broj_sorti !== 0">
            <p class="gornji_text" v-html="Math.round(povrsina) / 100"></p>
            <p class="donji_text">ar</p>
          </div>
        </template>
        <template v-else>
          <div class="div_prozorce">
            <p class="gornji_text">-</p>
            <p class="donji_text">ar</p>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <!-- /.addingToTank -->

    <TokenComponent ref="frmtoken" />
  </v-container>
</template>

        <script>
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import MyComponentIzdatnice from "./AddingNewComponent";

export default {
  props: [
    "vineyardId",
    "ID",
    "plaintObject",
    "vineyardOperationExecution",
    "item",
    "datumOperacije",
    "izmena_init",
  ],
  name: "VineyardOperationMaterialComponent",
  components: {
    TokenComponent,
    MyComponentIzdatnice,
  },
  data: () => ({
    visinaFlexa: 425,
    visina: 435,
    search: "",
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000,
    },
    valid: true,
    headers_modal_izabrani_redovi: [
      { text: "Red", value: "rowNumber", align: "center", sortable: true },
      { text: "Parcela", value: "rowNumber", align: "center", sortable: false },
      { text: "Tabla", value: "rowNumber", align: "center", sortable: false },
      { text: "Sorta", value: "rowNumber", align: "center", sortable: false },
      {
        text: "Od čokota",
        value: "plantNumberFrom",
        align: "center",
        sortable: false,
      },
      {
        text: "Do čokota",
        value: "plantNumberTo",
        align: "center",
        sortable: false,
      },
      {
        text: "Odrađeno od",
        value: "executedNumberFrom",
        align: "center",
        sortable: false,
      },
      {
        text: "Odrađeno do",
        value: "executedNumberTo",
        align: "center",
        sortable: false,
      },
      {
        text: "Broj čokota",
        value: "",
        align: "center",
        sortable: false,
      },
    ],
    headers_modal_izabrani_redovi_pom: [],
    vinery_block_select: [],
    vinery_block_items: [],
    grape_variety_select: [],
    grape_variety_items: [],

    selected_izabrani_redovi: [],
    selected_izabrani_redovi_pom: [],
    items_modal_izabrani_redovi: [],
    items_modal_izabrani_redovi_pom: [],
    // clear_form: false,
    expanded_rows: false,

    opis: undefined,
    jm_items: [],
    jm_grozdja_select: undefined,
    kolicina: undefined,
    id_berbe: 0,
    izmena: false,
    ucitano: false,

    broj_sorti: 0,
    broj_redova: 0,
    broj_kalemova: 0,
    povrsina: 0,
    secer: undefined,
    kiselina: undefined,

    prikazi: false,
    minOdReda: 0,
    maxOdReda: undefined,
    minDoReda: 0,
    maxDoReda: undefined,
    minOdCokota: 0,
    maxOdCokota: undefined,
    minDoCokota: 0,
    maxDoCokota: undefined,
    odReda: undefined,
    doReda: undefined,
    odCokota: undefined,
    doCokota: undefined,
    par_nepar_items: [
      {
        id: 1,
        name: "Parni",
      },
      {
        id: 2,
        name: "Neparni",
      },
    ],
    par_nepar_select: undefined,

    vinery_table_select: [],
    vinery_table_items: [],
    loading: false,
    loadingSorte: false,
    tables: [],

tekstBiljka: "",
tekstBiljka1: "",
tekstBiljka2: "",
tekstBiljka3: "",
tekstBiljka4: "",
tekstBiljka5: "",
tekstBiljka6: "",
vinarija: true,
    ucitavanje: true
  }),
  methods: {
    dodajParcelu(entry) {
      let obj;

      let index = this.plaintObject.vineyardOperationBlocks.findIndex(
        (x) => x.vineyardBlock.id === entry.blockId
      );

      // if (index >= 0)
      //   obj = {
      //     id: this.plaintObject.vineyardOperationBlocks[index].id,
      //     vineyardBlock: {
      //       id: entry.blockId,
      //     },
      //   };
      // else
        obj = {
          vineyardBlock: {
            id: entry.blockId,
          },
        };

      index = this.blocks.findIndex(
        (x) => x.vineyardBlock.id === entry.blockId
      );

      if (index === -1) this.blocks.push(obj);
    },
    dodajTablu(entry) {
      let obj;

      let index = this.plaintObject.vineyardOperationTables.findIndex(
        (x) => x.vineyardTable.id === entry.tableId
      );

      // if (index >= 0)
      //   obj = {
      //     id: this.plaintObject.vineyardOperationTables[index].id,
      //     vineyardTable: {
      //       id: entry.tableId,
      //     },
      //   };
      // else
        obj = {
          vineyardTable: {
            id: entry.tableId,
          },
        };

      index = this.tables.findIndex(
        (x) => x.vineyardTable.id === entry.tableId
      );

      if (index === -1) this.tables.push(obj);
    },
    izracunajMere() {
      let _this = this;
      var counts = {};
      var rows = {};

      this.broj_kalemova = 0;
      this.povrsina = 0;

      this.selected_izabrani_redovi_pom.forEach(function (e) {
        _this.broj_kalemova =
          _this.broj_kalemova +
          Number(e.executedNumberTo - e.executedNumberFrom + 1);

        counts[e.grapeVarietyId] = 1 + (counts[e.grapeVarietyId] || 0);

        rows[e.id_pom] = 1 + (rows[e.id_pom] || 0);
        // rows[e.vineyardRowId] = 1 + (rows[e.vineyardRowId] || 0);

        _this.povrsina =
          _this.povrsina +
          Number(e.distanceBetweenRows) *
            (e.executedNumberTo - e.executedNumberFrom + 1) *
            Number(e.distanceBetweenPlants);
      });

      this.broj_sorti = Object.keys(counts).length;
      this.broj_redova = Object.keys(rows).length;

      // this.povrsina =
      //   Math.round(this.objVineyardPlaint.surface * 100) / 100;
    },
    sakriFiltere(a) {
      if (a) {
        this.visinaFlexa = 320;
        this.visina = 330;

        this.$refs.element3.reset();
        this.$refs.element4.reset();
        this.$refs.element5.reset();
        this.$refs.element6.reset();
        this.$refs.element7.reset();
      } else {
        this.visinaFlexa = 425;
        this.visina = 435;
      }
    },
    OdReda(e) {
      this.minDoReda = Number(e);
    },
    DoReda(e) {
      this.maxOdReda = Number(e);
    },
    OdCokota(e) {
      this.minDoCokota = Number(e);
    },
    DoCokota(e) {
      this.maxOdCokota = Number(e);
    },
    popuniParenta(obj) {
      let parent = null;

      let index = this.items_modal_izabrani_redovi.findIndex(
        (v) => v.rowId === Number(obj.id_pom.split("_")[0])
      );

      if (index >= 0) {
        let indexPom = this.selected_izabrani_redovi.findIndex(
          (v) => v === this.items_modal_izabrani_redovi[index]
        );
        if (indexPom < 0) {
          this.selected_izabrani_redovi.push(
            this.items_modal_izabrani_redovi[index]
          );
          // parent = this.items_modal_izabrani_redovi[index];
        }
      }

      return parent;
    },
    pronadjiParenta(obj) {
      let parent = null;

      let index = this.items_modal_izabrani_redovi.findIndex(
        (v) => v.rowId === Number(obj.id_pom.split("_")[0])
      );

      parent = this.items_modal_izabrani_redovi[index];

      return parent;
    },
    resetujFiltere(){
      this.$refs.element3.reset();
          this.$refs.element4.reset();
          this.$refs.element5.reset();
          this.$refs.element6.reset();
          this.$refs.element7.reset();
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (Number(this.odReda) > Number(this.doReda)) {
          alert("Vrednost polja Od reda je veća od vredosti polja Do reda.");
          this.DoReda = undefined;
        } else if (Number(this.odCokota) > Number(this.doCokota)) {
          alert(
            "Vrednost polja " + this.tekstBiljka4 + " je veća od vredosti polja " + this.tekstBiljka5 + "."
          );
          this.doCokota = undefined;
        } else {
          // this.toggleAll2();

          this.selected_izabrani_redovi = [];
          // this.selected_izabrani_redovi_pom = [];

          let _this = this;

          this.items_modal_izabrani_redovi_pom.forEach(function (entry) {
            let bool = true;

            if (
              entry.rowNumber >= Number(_this.odReda) &&
              entry.rowNumber <= Number(_this.doReda)
            ) {
              if (_this.par_nepar_select === undefined) {
                if (_this.odCokota === undefined || _this.odCokota === "")
                  entry.executedNumberFrom = entry.plantNumberFrom;
                else if (_this.doCokota < entry.plantNumberFrom) {
                  bool = false;

                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                } else if (Number(_this.odCokota) > 0) {
                  if (
                    Number(_this.odCokota) >= entry.plantNumberFrom &&
                    Number(_this.odCokota) <= entry.plantNumberTo
                  )
                    entry.executedNumberFrom = Number(_this.odCokota);
                  else if (Number(_this.odCokota) <= entry.plantNumberTo)
                    entry.executedNumberFrom = entry.plantNumberFrom;
                }

                if (_this.doCokota === undefined || _this.doCokota === "")
                  entry.executedNumberTo = entry.plantNumberTo;
                else if (_this.odCokota > entry.plantNumberTo) {
                  bool = false;

                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                } else if (Number(_this.doCokota) > 0) {
                  if (
                    Number(_this.doCokota) >= entry.plantNumberFrom &&
                    Number(_this.doCokota) <= entry.plantNumberTo
                  )
                    entry.executedNumberTo = Number(_this.doCokota);
                  else if (Number(_this.doCokota) >= entry.plantNumberTo)
                    entry.executedNumberTo = entry.plantNumberTo;
                }

                if (
                  entry.executedNumberFrom === null ||
                  entry.executedNumberTo === null
                ) {
                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                }

                if (
                  entry.executedNumberFrom !== null &&
                  entry.executedNumberTo !== null &&
                  bool
                ) {
                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  _this.selected_izabrani_redovi_pom.push(entry);
                  _this.popuniParenta(entry);
                }
              } else if (
                _this.par_nepar_select.id === 1 &&
                _this.parNepar(entry.rowNumber)
              ) {
                if (_this.odCokota === undefined || _this.odCokota === "")
                  entry.executedNumberFrom = entry.plantNumberFrom;
                else if (_this.doCokota < entry.plantNumberFrom) {
                  bool = false;

                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                } else if (Number(_this.odCokota) > 0) {
                  if (
                    Number(_this.odCokota) >= entry.plantNumberFrom &&
                    Number(_this.odCokota) <= entry.plantNumberTo
                  )
                    entry.executedNumberFrom = Number(_this.odCokota);
                  else if (Number(_this.odCokota) <= entry.plantNumberTo)
                    entry.executedNumberFrom = entry.plantNumberFrom;
                }

                if (_this.doCokota === undefined || _this.doCokota === "")
                  entry.executedNumberTo = entry.plantNumberTo;
                else if (_this.odCokota > entry.plantNumberTo) {
                  bool = false;

                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                } else if (Number(_this.doCokota) > 0) {
                  if (
                    Number(_this.doCokota) >= entry.plantNumberFrom &&
                    Number(_this.doCokota) <= entry.plantNumberTo
                  )
                    entry.executedNumberTo = Number(_this.doCokota);
                  else if (Number(_this.doCokota) >= entry.plantNumberTo)
                    entry.executedNumberTo = entry.plantNumberTo;
                }

                if (
                  entry.executedNumberFrom === null ||
                  entry.executedNumberTo === null
                ) {
                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                }

                if (
                  entry.executedNumberFrom !== null &&
                  entry.executedNumberTo !== null &&
                  bool
                ) {
                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  _this.selected_izabrani_redovi_pom.push(entry);
                  _this.popuniParenta(entry);
                }
              } else if (
                _this.par_nepar_select.id === 2 &&
                !_this.parNepar(entry.rowNumber)
              ) {
                if (_this.odCokota === undefined || _this.odCokota === "")
                  entry.executedNumberFrom = entry.plantNumberFrom;
                else if (_this.doCokota < entry.plantNumberFrom) {
                  bool = false;

                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                } else if (Number(_this.odCokota) > 0) {
                  if (
                    Number(_this.odCokota) >= entry.plantNumberFrom &&
                    Number(_this.odCokota) <= entry.plantNumberTo
                  )
                    entry.executedNumberFrom = Number(_this.odCokota);
                  else if (Number(_this.odCokota) <= entry.plantNumberTo)
                    entry.executedNumberFrom = entry.plantNumberFrom;
                }

                if (_this.doCokota === undefined || _this.doCokota === "")
                  entry.executedNumberTo = entry.plantNumberTo;
                else if (_this.odCokota > entry.plantNumberTo) {
                  bool = false;

                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                } else if (Number(_this.doCokota) > 0) {
                  if (
                    Number(_this.doCokota) >= entry.plantNumberFrom &&
                    Number(_this.doCokota) <= entry.plantNumberTo
                  )
                    entry.executedNumberTo = Number(_this.doCokota);
                  else if (Number(_this.doCokota) >= entry.plantNumberTo)
                    entry.executedNumberTo = entry.plantNumberTo;
                }

                if (
                  entry.executedNumberFrom === null ||
                  entry.executedNumberTo === null
                ) {
                  entry.executedNumberFrom = null;
                  entry.executedNumberTo = null;
                }

                if (
                  entry.executedNumberFrom !== null &&
                  entry.executedNumberTo !== null &&
                  bool
                ) {
                  let ind = _this.selected_izabrani_redovi_pom.findIndex(
                    (x) => x.id_pom === entry.id_pom
                  );

                  if (ind >= 0) {
                    _this.selected_izabrani_redovi_pom.splice(ind, 1);
                  }

                  _this.selected_izabrani_redovi_pom.push(entry);
                  _this.popuniParenta(entry);
                }
              }
            }
          });

          if (this.selected_izabrani_redovi_pom.length === 0)
            alert("Ni jedan red nije izabran, proverite unešene kriterijume.");
          else {
            this.selected_izabrani_redovi_pom.forEach(function (entry) {
              let parent = _this.pronadjiParenta(entry);

              if (parent !== null && parent !== undefined)
                _this.selektovanjeParenta(entry, parent);
            });

            this.izracunajMere();
          }

          this.$refs.element3.reset();
          this.$refs.element4.reset();
          this.$refs.element5.reset();
          this.$refs.element6.reset();
          this.$refs.element7.reset();
        }
      }
    },
    parNepar(broj) {
      let par = true;

      if (broj % 2 !== 0) par = false;

      return par;
    },
    toggleAll() {
      this.expanded_rows = !this.expanded_rows;

      for (let i = 0; i < this.items_modal_izabrani_redovi.length; i += 1) {
        const item = this.items_modal_izabrani_redovi[i];

        if (item.positions.length > 0)
          this.$set(this.$refs.dTable.expanded, item.rowId, this.expanded_rows);
      }
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/2",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          let pp = response.data;

          let pronadjiObj = pp.findIndex((item1) => item1.mark === "g");

          pp.splice(pronadjiObj, 1);

          this.jm_items = pp;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/2",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      let pp = response.data;

                      let pronadjiObj = pp.findIndex(
                        (item1) => item1.mark === "g"
                      );

                      pp.splice(pronadjiObj, 1);

                      this.jm_items = pp;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    toggleAll_izabrani_tankovi(e) {
      this.items_modal_izabrani_redovi.forEach(function (entry) {
        entry.indeterminate = false;
      });

      if (this.selected_izabrani_redovi.length) {
        let _this = this;
        this.items_modal_izabrani_redovi_pom.forEach(function (entry) {
          entry.executedNumberFrom = null;
          entry.executedNumberTo = null;
        });

        this.selected_izabrani_redovi_pom = [];
        this.selected_izabrani_redovi = [];
      } else {
        this.selected_izabrani_redovi =
          this.items_modal_izabrani_redovi.slice();

        let _this = this;
        this.items_modal_izabrani_redovi_pom.forEach(function (entry) {
          entry.executedNumberFrom = entry.plantNumberFrom;
          entry.executedNumberTo = entry.plantNumberTo;

          _this.selected_izabrani_redovi_pom.push(entry);
        });
      }

      this.izracunajMere();
    },
    formatRedova(niz) {
      let tekst = "";

      if (niz.length > 0) {
        niz.forEach(function (entry) {
          tekst = tekst + entry + ", ";
        });

        tekst = tekst.substring(0, tekst.length - 2);
      }

      return tekst;
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaKalem2(broj) {
      let tekst = "";

      if (this.vinarija){
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      }
      else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";        
      };

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    closeModalInModal_izbor_redova() {
      let blocks = [];
      this.ucitano = false;

      if (
        this.vinery_block_items.length > 0 &&
        this.vinery_block_select !== undefined
      )
        if (this.vinery_block_select.length > 0) {
          this.vinery_block_select.forEach(function (entry) {
            let obj;

            obj = {
              vineyardBlock: {
                id: entry.id,
              },
            };
            blocks.push(obj);
          });
        }

      let varieties = [];

      if (
        this.grape_variety_items.length > 0 &&
        this.grape_variety_select !== undefined
      )
        if (this.grape_variety_select.length > 0) {
          this.grape_variety_select.forEach(function (entry) {
            let obj;

            obj = {
              grapeVariety: {
                id: entry.id,
              },
            };

            varieties.push(obj);
          });
        }

      let complex;

      complex = {
        rows: this.selected_izabrani_redovi_pom,
        blocks: blocks,
        varieties: varieties,
      };

      this.$emit("close", complex);
    },
    changeSelect(props_modal, selektovan) {
      if (this.prvi_prolaz === undefined) this.prvi_prolaz = true;

      if (
        props_modal.item.plantNumberFrom !== null &&
        props_modal.item.plantNumberTo !== null
      )
        if (selektovan !== undefined)
          if (!selektovan)
            if (
              props_modal.item.executedNumberFrom === undefined ||
              props_modal.item.executedNumberTo === undefined
            ) {
              alert(
                "Uneti od kog " + this.tekstBiljka3 + " i koja količina " + this.tekstBiljkaa + " će biti zasađena u izabranom redu."
              );
              props_modal.selected = false;
            } else props_modal.selected = !props_modal.selected;
          else props_modal.selected = !props_modal.selected;
        else {
          if (this.prvi_prolaz) {
            // props_modal.item.executedNumberFrom = props_modal.item.plantNumberFrom;
            // props_modal.item.executedNumberTo = props_modal.item.plantNumberTo;
            props_modal.selected = !props_modal.selected;
          }
          this.prvi_prolaz = !this.prvi_prolaz;
        }
      else {
        if (
          props_modal.item.plantNumberFrom === null ||
          props_modal.item.plantNumberTo === null
        )
          if (selektovan !== undefined)
            if (!selektovan)
              if (
                props_modal.item.executedNumberFrom === undefined ||
                props_modal.item.executedNumberTo === undefined
              ) {
                alert(
                  "Uneti od kog " + this.tekstBiljka3 + " i koja količina " + this.tekstBiljkaa + " će biti zasađena u izabranom redu."
                );
                props_modal.selected = false;
              } else if (
                Number(props_modal.item.executedNumberFrom) <
                Number(props_modal.item.executedNumberTo)
              )
                props_modal.selected = !props_modal.selected;
              else alert(this.tekstBiljka2 + " u redu mora da bude veći od početnog.");
            else props_modal.selected = !props_modal.selected;
          else {
            if (this.prvi_prolaz) {
              if (
                props_modal.item.executedNumberFrom === undefined ||
                props_modal.item.executedNumberTo === undefined
              ) {
                alert(
                  "Uneti od kog " + this.tekstBiljka3 + " i koja količina " + this.tekstBiljkaa + " će biti zasađena u izabranom redu."
                );
                props_modal.selected = false;
              } else if (
                Number(props_modal.item.executedNumberFrom) <
                Number(props_modal.item.executedNumberTo)
              )
                props_modal.selected = !props_modal.selected;
              else alert(this.tekstBiljka2 + " u redu mora da bude veći od početnog.");
            }
            this.prvi_prolaz = !this.prvi_prolaz;
          }
        else {
          if (this.prvi_prolaz)
            if (props_modal.selected !== undefined)
              props_modal.selected = !props_modal.selected;
            else props_modal.selected = true;

          this.prvi_prolaz = !this.prvi_prolaz;
        }
      }

      let _this = this;

      if (this.prvi_prolaz) {
        // if(props_modal.selected !== undefined)
        //   props_modal.selected = !props_modal.selected;
        // else
        //   props_modal.selected = false;

        props_modal.item.indeterminate = false;

        if (!props_modal.selected) {
          _this.items_modal_izabrani_redovi_pom.forEach(function (entry) {
            if (entry.id_pom.indexOf(props_modal.item.rowId + "_") === 0) {
              let pronadjiObj = _this.selected_izabrani_redovi_pom.find(
                (item1) => item1.id_pom === entry.id_pom
              );

              if (pronadjiObj === undefined)
                _this.selected_izabrani_redovi_pom.push(entry);
              // let indexPom1 = _this.selected_izabrani_redovi_pom.find(elem => elem.id_pom === entry.id_pom);
            }
          });
        } else {
          let pomArray = [];

          _this.selected_izabrani_redovi_pom.forEach(function (entry) {
            if (entry.id_pom.indexOf(props_modal.item.rowId + "_") === 0) {
              let indexPom = _this.selected_izabrani_redovi_pom.indexOf(entry);
              pomArray.push(indexPom);
            }
          });

          pomArray
            .slice()
            .reverse()
            .forEach(function (entry) {
              _this.selected_izabrani_redovi_pom.splice(entry, 1);
            });
        }
      } else {
        if (props_modal.selected) {
          let pomArray = [];

          _this.selected_izabrani_redovi_pom.forEach(function (entry) {
            if (entry.id_pom.indexOf(props_modal.item.rowId + "_") === 0) {
              let indexPom = _this.selected_izabrani_redovi_pom.indexOf(entry);
              pomArray.push(indexPom);
            }
          });

          pomArray
            .slice()
            .reverse()
            .forEach(function (entry) {
              _this.selected_izabrani_redovi_pom.splice(entry, 1);
            });

          props_modal.item.positions.forEach(function (entry) {
            entry.executedNumberFrom = null;
            entry.executedNumberTo = null;
          });
        } else
          props_modal.item.positions.forEach(function (entry) {
            entry.executedNumberFrom = entry.plantNumberFrom;
            entry.executedNumberTo = entry.plantNumberTo;
          });
      }

      this.izracunajMere();
    },
    changeSelectItem(props_modal, selektovan, parent) {
      if (this.prvi_prolaz === undefined) this.prvi_prolaz = true;

      if (
        props_modal.item.plantNumberFrom !== null &&
        props_modal.item.plantNumberTo !== null
      )
        if (selektovan !== undefined)
          if (!selektovan)
            if (
              props_modal.item.executedNumberFrom === undefined ||
              props_modal.item.executedNumberTo === undefined
            ) {
              alert(
                "Uneti od kog " + this.tekstBiljka3 + " i koja količina " + this.tekstBiljkaa + " će biti zasađena u izabranom redu."
              );
              props_modal.selected = false;
            } else props_modal.selected = !props_modal.selected;
          else props_modal.selected = !props_modal.selected;
        else {
          if (this.prvi_prolaz) {
            // props_modal.item.executedNumberFrom = props_modal.item.plantNumberFrom;
            // props_modal.item.executedNumberTo = props_modal.item.plantNumberTo;
            props_modal.selected = !props_modal.selected;
          }
          this.prvi_prolaz = !this.prvi_prolaz;
        }
      else {
        if (
          props_modal.item.plantNumberFrom === null ||
          props_modal.item.plantNumberTo === null
        )
          if (selektovan !== undefined)
            if (!selektovan)
              if (
                props_modal.item.executedNumberFrom === undefined ||
                props_modal.item.executedNumberTo === undefined
              ) {
                alert(
                  "Uneti od kog " + this.tekstBiljka3 + " i koja količina " + this.tekstBiljkaa + " će biti zasađena u izabranom redu."
                );
                props_modal.selected = false;
              } else if (
                Number(props_modal.item.executedNumberFrom) <
                Number(props_modal.item.executedNumberTo)
              )
                props_modal.selected = !props_modal.selected;
              else alert(this.tekstBiljka2 + " u redu mora da bude veći od početnog.");
            else props_modal.selected = !props_modal.selected;
          else {
            if (this.prvi_prolaz) {
              if (
                props_modal.item.executedNumberFrom === undefined ||
                props_modal.item.executedNumberTo === undefined
              ) {
                alert(
                  "Uneti od kog " + this.tekstBiljka3 + " i koja količina " + this.tekstBiljkaa + " će biti zasađena u izabranom redu."
                );
                props_modal.selected = false;
              } else if (
                Number(props_modal.item.executedNumberFrom) <
                Number(props_modal.item.executedNumberTo)
              )
                props_modal.selected = !props_modal.selected;
              else alert(this.tekstBiljka2 + " u redu mora da bude veći od početnog.");
            }
            this.prvi_prolaz = !this.prvi_prolaz;
          }
        else {
          if (this.prvi_prolaz)
            if (props_modal.selected !== undefined)
              props_modal.selected = !props_modal.selected;
            else props_modal.selected = true;

          this.prvi_prolaz = !this.prvi_prolaz;
        }
      }

      if (props_modal.selected) {
        props_modal.item.executedNumberFrom = null;
        props_modal.item.executedNumberTo = null;
      } else {
        props_modal.item.executedNumberFrom = props_modal.item.plantNumberFrom;
        props_modal.item.executedNumberTo = props_modal.item.plantNumberTo;
      }

      if (this.prvi_prolaz) {
        this.selektovanjeParenta(props_modal, parent);
        this.izracunajMere();
      }
    },
    selektovanjeParenta(props_modal, parent) {
      let objekat;

      if (props_modal.item !== undefined) objekat = props_modal.item;
      else objekat = props_modal;

      let pomocniID = Number(objekat.id_pom.split("_")[0]);
      let momocniObj = [];
      let pomocniBool = true;
      let pomocniIndex = this.items_modal_izabrani_redovi.findIndex(
        (x) => x.rowId === pomocniID
      );

      this.items_modal_izabrani_redovi[pomocniIndex].indeterminate = true;

      let brojPozicija = 0; // = this.items_modal_izabrani_redovi[pomocniIndex].positions.length;

      let _this = this;

      this.items_modal_izabrani_redovi[pomocniIndex].positions.forEach(
        function (entry) {
          let pomocniIndex2 = _this.selected_izabrani_redovi_pom.findIndex(
            (x) => x.id_pom === entry.id_pom
          );

          if (pomocniIndex2 > -1) brojPozicija = brojPozicija + 1;
        }
      );

      if (brojPozicija === 0) {
        parent.selected = false;
        parent.indeterminate = false;
      } else if (
        this.items_modal_izabrani_redovi[pomocniIndex].positions.length ===
        brojPozicija
      ) {
        parent.selected = true;
        parent.indeterminate = false;
      } else {
        parent.selected = true;
        parent.indeterminate = true;
      }
    },
    proveriSortu() {
      let _this = this;
      let odgovor = false;

      this.plaintObject.vineyardOperationHarvests.forEach(function (e) {
        e.vineyardOperationRows.forEach(function (e1) {
          if (e1.grapeVariety.id === _this.grape_variety_select.id)
            odgovor = true;
        });
      });

      return odgovor;
    },
    changeSifarnik() {
      if (this.$refs.form1.validate()) {
        if (this.proveriSortu() && this.id_berbe === 0)
          alert("Sorta je već izabrana, nije moguće novo dodavanje.");
        // else if (this.id_berbe === 0) this.closeModalInModal_izbor_redova();
        else {
          if (this.selected_izabrani_redovi_pom.length === 0)
            alert(this.tekstBiljka6);
          else {
            this.blocks = [];
            this.tables = [];

            let varieties = [];

            if (this.grape_variety_select !== undefined) {
              let obj = {
                grapeVariety: {
                  id: this.grape_variety_select.id,
                },
              };

              varieties.push(obj);
            }

            let pomObj;
            let pomArray = [];
            let povrsina = 0;
            let _this = this;

            console.log(this.plaintObject.vineyardOperationBlocks);

            this.selected_izabrani_redovi_pom.forEach(function (entry) {
              console.log(entry);

              if (entry.blockId !== null) _this.dodajParcelu(entry);
              if (entry.tableId !== null) _this.dodajTablu(entry);

              let lokID;

              
              let niz = entry.id_pom.split("_");
              lokID = niz[0];

              let lokTableId = 0;
              if (niz.length === 4) lokTableId = niz[3];

              let from;
              let to;

              if (entry.executedNumberFrom !== null)
                from = entry.executedNumberFrom;
              else from = entry.plantNumberFrom;

              if (entry.executedNumberTo !== null) to = entry.executedNumberTo;
              else to = entry.plantNumberTo;

              if (lokTableId === 0) {
                if (
                  entry.vineyardOperationExecutionId !== undefined &&
                  entry.vineyardOperationExecutionId !== null
                )
                  pomObj = {
                    executedNumberFrom: from,
                    executedNumberTo: to,
                    id: entry.vineyardOperationExecutionId,
                    vineyardRow: {
                      id: lokID,
                    },
                    description: "",
                    harvestQuantity: null,
                    harvestUnitOfMeasure: null,
                    grapeVariety: {
                      id: entry.grapeVarietyId,
                    },
                  };
                else
                  pomObj = {
                    executedNumberFrom: from,
                    executedNumberTo: to,
                    vineyardRow: {
                      id: lokID,
                    },
                    description: "",
                    harvestQuantity: null,
                    harvestUnitOfMeasure: null,
                    grapeVariety: {
                      id: entry.grapeVarietyId,
                    },
                  };
              } else {
                if (
                  entry.vineyardOperationExecutionId !== undefined &&
                  entry.vineyardOperationExecutionId !== null
                )
                  pomObj = {
                    executedNumberFrom: from,
                    executedNumberTo: to,
                    id: entry.vineyardOperationExecutionId,
                    vineyardRow: {
                      id: lokID,
                    },
                    vineyardTable: {
                      id: lokTableId,
                    },
                    description: "",
                    harvestQuantity: null,
                    harvestUnitOfMeasure: null,
                    grapeVariety: {
                      id: entry.grapeVarietyId,
                    },
                  };
                else
                  pomObj = {
                    executedNumberFrom: from,
                    executedNumberTo: to,
                    vineyardRow: {
                      id: lokID,
                    },
                    vineyardTable: {
                      id: lokTableId,
                    },
                    description: "",
                    harvestQuantity: null,
                    harvestUnitOfMeasure: null,
                    grapeVariety: {
                      id: entry.grapeVarietyId,
                    },
                  };
              }

              pomArray.push(pomObj);
            });

            let pomocniObjekat;

            if (this.blocks.length > 0) {
              if (this.id_berbe > 0)
                pomocniObjekat = {
                  id: this.id_berbe,
                  quantity: this.kolicina,
                  unitOfMeasure: {
                    id: this.jm_grozdja_select.id,
                  },
                  description: this.opis,
                  vineyardOperationRows: pomArray,
                  surface: this.povrsina,
                  vineyardOperationBlocks: this.blocks,
                  vineyardOperationTables:
                    this.tables.length > 0 ? this.tables : null,
                  sugar: this.secer !== undefined ? this.secer : null,
                  acid: this.kiselina !== undefined ? this.kiselina : null,
                };
              else
                pomocniObjekat = {
                  quantity: this.kolicina,
                  unitOfMeasure: {
                    id: this.jm_grozdja_select.id,
                  },
                  description: this.opis,
                  vineyardOperationRows: pomArray,
                  surface: this.povrsina,
                  vineyardOperationBlocks: this.blocks,
                  vineyardOperationTables:
                    this.tables.length > 0 ? this.tables : null,
                  sugar: this.secer !== undefined ? this.secer : null,
                  acid: this.kiselina !== undefined ? this.kiselina : null,
                };
            } else {
              if (this.id_berbe > 0)
                pomocniObjekat = {
                  id: this.id_berbe,
                  quantity: this.kolicina,
                  unitOfMeasure: {
                    id: this.jm_grozdja_select.id,
                  },
                  description: this.opis,
                  vineyardOperationRows: pomArray,
                  surface: this.povrsina,
                  sugar: this.secer !== undefined ? this.secer : null,
                  acid: this.kiselina !== undefined ? this.kiselina : null,
                };
              else
                pomocniObjekat = {
                  quantity: this.kolicina,
                  unitOfMeasure: {
                    id: this.jm_grozdja_select.id,
                  },
                  description: this.opis,
                  vineyardOperationRows: pomArray,
                  surface: this.povrsina,
                  sugar: this.secer !== undefined ? this.secer : null,
                  acid: this.kiselina !== undefined ? this.kiselina : null,
                };
            }

            let pomocniNiz = [];
            pomocniNiz.push(pomocniObjekat);

            this.vineyardOperationExecution.vineyardOperationHarvests =
              pomocniNiz;

            this.vineyardOperationExecution.vineyardOperationBlocks = this.blocks;
            this.vineyardOperationExecution.vineyardOperationTables = this.tables;

            this.vineyardOperationExecution.vineyardOperationGrapeVarietys =
              varieties;

            this.$http
              .put(
                this.globalServiceLocation +
                  this.globalPort +
                  "/vineyard_operation_execution/update",
                this.vineyardOperationExecution,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.getAllSifarnik();

                this.closeModalInModal_izbor_redova();
              })
              .catch((e) => {
                if (!e.response) {
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .put(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/vineyard_operation_execution/update",
                            complexObjectGlobal,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.getAllSifarnik();
                            this.closeModalInModal_izbor_redova();
                          })
                          .catch((e) => {
                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        }
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    getAllSifarnik() {
      if (this.vineyardId !== undefined) {
        let _this = this;

        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard/" +
              this.vineyardId +
              "/blocks",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);
            _this.vinery_block_items = response.data;

            _this.ucitano = true;

            // _this.promenaVisine();

            // if (response.data.length === 0)
            if (_this.item !== undefined) {
              if (_this.item.vineyardOperationBlocks.length > 0) {
                _this.item.vineyardOperationBlocks.forEach(function (entry) {
                  let pronadjiObj = _this.vinery_block_select.findIndex(
                    (item1) => item1.id === entry.vineyardBlock.id
                  );

                  if (pronadjiObj < 0)
                    _this.vinery_block_select.push(entry.vineyardBlock);
                });
              }
            }
          })
          .catch((e) => {
            // // console.log(e.response);
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard/" +
                          this.vineyardId +
                          "/blocks",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        _this.vinery_block_items = response.data;

                        _this.ucitano = true;

                        // _this.promenaVisine();

                        // if (response.data.length === 0)
                        if (_this.item !== undefined) {
                          if (_this.item.vineyardOperationBlocks.length > 0) {
                            _this.item.vineyardOperationBlocks.forEach(
                              function (entry) {
                                _this.vinery_block_select.push(
                                  entry.vineyardBlock
                                );
                              }
                            );
                          }
                        }
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    changeGrapeVariety(a) {
      this.items_modal_izabrani_redovi = [];
      this.selected_izabrani_redovi = [];
      this.items_modal_izabrani_redovi_pom = [];
      this.selected_izabrani_redovi_pom = [];

      if (a !== undefined) {
        if (this.vineyardOperationExecution !== undefined) {
          if (this.vineyardOperationExecution.id !== undefined) {
            if (this.id_berbe > 0) this.getAllSifarnik2(false);
            else this.getAllSifarnik2(true);
          } else this.getAllSifarnik2(true);
        } else this.getAllSifarnik2(true);
      }

      // this.promenaVisine();
    },

    // promenaVisine() {
    //   if (this.vinery_block_items.length !== 0) {
    //     if (this.vinery_block_select !== undefined) {
    //       if (this.vinery_block_select.length !== 0) {
    //         if (this.grape_variety_select !== undefined) {
    //           if (this.grape_variety_select.length !== 0) {
    //             this.visina = 460;
    //           } else this.visina = 470;
    //         } else {
    //           this.visina = 470;
    //         }
    //       } else {
    //         if (this.grape_variety_select !== undefined) {
    //           if (this.grape_variety_select.length !== 0) {
    //             this.visina = 470;
    //           } else {
    //             this.visina = 435;
    //           }
    //         } else {
    //           this.visina = 435;
    //         }
    //       }
    //     } else {
    //       if (this.grape_variety_select !== undefined) {
    //         if (this.grape_variety_select.length !== 0) {
    //           this.visina = 470;
    //         } else {
    //           this.visina = 435;
    //         }
    //       } else {
    //         this.visina = 435;
    //       }
    //     }
    //   } else {
    //     if (this.grape_variety_select !== undefined) {
    //       if (this.grape_variety_select.length !== 0) {
    //         this.visina = 540;
    //       } else {
    //         this.visina = 550;
    //       }
    //     } else {
    //       this.visina = 550;
    //     }
    //   }
    // },
    getAllSifarnik2(clear) {
      this.ucitavanje = true;
      this.resetujFiltere();
      
      let _this = this;
      let url;

      if (this.vineyardId !== undefined && this.ID !== undefined) {
        if (this.ID !== 0)
          url =
            "/vineyard_grape_variety_row/used_position_with_executed/" +
            this.ID;
        else
          url =
            "/vineyard_grape_variety_row/used_position_in_vineyard/" +
            this.vineyardId +
            "?dateTo=" +
            this.datumOperacije;

        if (
          this.vinery_block_select !== undefined &&
          this.vinery_block_select !== null &&
          this.vinery_block_select.length > 0
        ) {
          if (this.ID !== 0) url = url + "?";
          else url = url + "&";

          this.vinery_block_select.forEach(function (entry) {
            url = url + "blockId=" + entry.id + "&";
          });
        }

        if (
          this.vinery_table_select !== undefined &&
          this.vinery_table_select !== null &&
          this.vinery_table_select.length > 0
        ) {
          if (
            url.substring(url.length - 1) === "&" ||
            url.substring(url.length - 1) === "?"
          )
            url = url.substring(0, url.length - 1);

          if (this.ID !== 0 && url.indexOf("?") < 0) url = url + "?";
          else url = url + "&";

          this.vinery_table_select.forEach(function (entry) {
            url = url + "tableId=" + entry.id + "&";
          });
        }

        if (
          typeof this.grape_variety_select !== "undefined" &&
          this.grape_variety_select !== null &&
          this.grape_variety_select.length !== 0
        ) {
          if (this.ID !== 0) {
            if (url.substring(url.length - 1) !== "&") url = url + "?";
          } else url = url + "&";

          url = url + "grapeVarietyId=" + this.grape_variety_select.id + "&";
        }

        if (url.substring(url.length - 1) === "&")
          url = url.substring(0, url.length - 1);

        this.$http
          .get(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            _this.items_modal_izabrani_redovi = response.data;

            _this.selected_izabrani_redovi = [];
            // _this.selected_izabrani_redovi_pom = [];
            _this.items_modal_izabrani_redovi_pom = [];

            if (response.data.length > 0)
              _this.items_modal_izabrani_redovi.forEach(function (e) {
                // e.positions.forEach(function (e1) {
                //   if (typeof e1 === "object") {
                //     if (_this.ID === 0) {
                //       if (!clear)
                //         (e1["id_pom"] =
                //           e.rowId +
                //           "_" +
                //           e1.plantNumberFrom +
                //           "_" +
                //           e1.plantNumberTo),
                //             (e1["rowNumber"] = e.rowNumber),
                //           (e1["executedNumberFrom"] = e1.plantNumberFrom),
                //           (e1["executedNumberTo"] = e1.plantNumberTo),
                //           (e1["vineyardOperationExecutionId"] = null),
                //           (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                //       else
                //         (e1["id_pom"] =
                //           e.rowId +
                //           "_" +
                //           e1.plantNumberFrom +
                //           "_" +
                //           e1.plantNumberTo),
                //             (e1["rowNumber"] = e.rowNumber),
                //           (e1["executedNumberFrom"] = null),
                //           (e1["executedNumberTo"] = null),
                //           (e1["vineyardOperationExecutionId"] = null),
                //           (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                //     } else {
                //       if (_this.ID === 0) {
                //         let ind = _this.selected_izabrani_redovi_pom.findIndex(
                //           (x) =>
                //             x.id_pom ===
                //             e.rowId +
                //               "_" +
                //               e1.plantNumberFrom +
                //               "_" +
                //               e1.plantNumberTo
                //         );

                //         // const result = _this.selected_izabrani_redovi_pom.find( ({ id_pom }) => id_pom === e.rowId + "_" + e1.plantNumberFrom + "_" + e1.plantNumberTo );

                //         // if (typeof result === "object") {
                //         if (ind >= 0) {
                //           (e1["id_pom"] =
                //             e.rowId +
                //             "_" +
                //             e1.plantNumberFrom +
                //             "_" +
                //             e1.plantNumberTo),
                //             (e1["rowNumber"] = e.rowNumber),
                //             (e1["executedNumberFrom"] = e1.executedNumberFrom),
                //             (e1["executedNumberTo"] = e1.executedNumberTo),
                //             (e1["vineyardOperationExecutionId"] =
                //               e1.vineyardOperationExecutionId),
                //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                //         } else
                //           (e1["id_pom"] =
                //             e.rowId +
                //             "_" +
                //             e1.plantNumberFrom +
                //             "_" +
                //             e1.plantNumberTo),
                //             (e1["rowNumber"] = e.rowNumber),
                //             (e1["executedNumberFrom"] = e1.plantNumberFrom),
                //             (e1["executedNumberTo"] = e1.plantNumberTo),
                //             (e1["vineyardOperationExecutionId"] = null),
                //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                //       } else {
                //         if (
                //           e1.vineyardOperationExecutionId !== null &&
                //           _this.izmena
                //         ) {
                //           (e1["id_pom"] =
                //             e.rowId +
                //             "_" +
                //             e1.plantNumberFrom +
                //             "_" +
                //             e1.plantNumberTo),
                //             (e1["rowNumber"] = e.rowNumber),
                //             (e1["executedNumberFrom"] = e1.executedNumberFrom),
                //             (e1["executedNumberTo"] = e1.executedNumberTo),
                //             (e1["vineyardOperationExecutionId"] =
                //               e1.vineyardOperationExecutionId),
                //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);

                //           _this.selected_izabrani_redovi_pom.push(e1);
                //         } else
                //           (e1["id_pom"] =
                //             e.rowId +
                //             "_" +
                //             e1.plantNumberFrom +
                //             "_" +
                //             e1.plantNumberTo),
                //             (e1["rowNumber"] = e.rowNumber),
                //             (e1["executedNumberFrom"] = e1.executedNumberFrom),
                //             (e1["executedNumberTo"] = e1.executedNumberTo),
                //             (e1["vineyardOperationExecutionId"] =
                //               e1.vineyardOperationExecutionId),
                //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                //       }
                //     }

                //     _this.items_modal_izabrani_redovi_pom.push(e1);
                //   }
                // }, (e.indeterminate = false));

                e.positions.forEach(function (e1) {
                  if (typeof e1 === "object") {
                    if (_this.ID === 0) {
                      if (!clear)
                        (e1["id_pom"] =
                          e.rowId +
                          "_" +
                          e1.plantNumberFrom +
                          "_" +
                          e1.plantNumberTo +
                          (e1.tableId !== null ? "_" + e1.tableId : "")),
                          (e1["rowNumber"] = e.rowNumber),
                          (e1["executedNumberFrom"] = e1.plantNumberFrom),
                          (e1["executedNumberTo"] = e1.plantNumberTo),
                          (e1["vineyardOperationExecutionId"] = null),
                          (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                      else
                        (e1["id_pom"] =
                          e.rowId +
                          "_" +
                          e1.plantNumberFrom +
                          "_" +
                          e1.plantNumberTo +
                          (e1.tableId !== null ? "_" + e1.tableId : "")),
                          (e1["rowNumber"] = e.rowNumber),
                          (e1["executedNumberFrom"] = null),
                          (e1["executedNumberTo"] = null),
                          (e1["vineyardOperationExecutionId"] = null),
                          (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                    } else {
                      if (_this.ID === 0) {
                        let ind = _this.selected_izabrani_redovi_pom.findIndex(
                          (x) =>
                            x.id_pom ===
                            e.rowId +
                              "_" +
                              e1.plantNumberFrom +
                              "_" +
                              e1.plantNumberTo
                        );

                        if (ind >= 0) {
                          (e1["id_pom"] =
                            e.rowId +
                            "_" +
                            e1.plantNumberFrom +
                            "_" +
                            e1.plantNumberTo +
                            (e1.tableId !== null ? "_" + e1.tableId : "")),
                            (e1["rowNumber"] = e.rowNumber),
                            (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            (e1["executedNumberTo"] = e1.executedNumberTo),
                            (e1["vineyardOperationExecutionId"] =
                              e1.vineyardOperationExecutionId),
                            (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                        } else
                          (e1["id_pom"] =
                            e.rowId +
                            "_" +
                            e1.plantNumberFrom +
                            "_" +
                            e1.plantNumberTo +
                            (e1.tableId !== null ? "_" + e1.tableId : "")),
                            (e1["rowNumber"] = e.rowNumber),
                            (e1["executedNumberFrom"] = e1.plantNumberFrom),
                            (e1["executedNumberTo"] = e1.plantNumberTo),
                            (e1["vineyardOperationExecutionId"] = null),
                            (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                      } else {
                        if (e1.vineyardOperationExecutionId !== null) {
                          (e1["id_pom"] =
                            e.rowId +
                            "_" +
                            e1.plantNumberFrom +
                            "_" +
                            e1.plantNumberTo +
                            (e1.tableId !== null ? "_" + e1.tableId : "")),
                            (e1["rowNumber"] = e.rowNumber),
                            (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            (e1["executedNumberTo"] = e1.executedNumberTo),
                            (e1["vineyardOperationExecutionId"] =
                              e1.vineyardOperationExecutionId),
                            (e1["distanceBetweenRows"] = e.distanceBetweenRows);

                          let ind =
                            _this.selected_izabrani_redovi_pom.findIndex(
                              (x) =>
                                x.id_pom ===
                                e.rowId +
                                  "_" +
                                  e1.plantNumberFrom +
                                  "_" +
                                  e1.plantNumberTo +
                                  (e1.tableId !== null ? "_" + e1.tableId : "")
                            );

                          if (ind >= 0) {
                            _this.selected_izabrani_redovi_pom.splice(ind, 1);
                          }

                          _this.selected_izabrani_redovi_pom.push(e1);
                        } else if (e1.vineyardOperationDestroyingId !== null) {
                          (e1["id_pom"] =
                            e.rowId +
                            "_" +
                            e1.plantNumberFrom +
                            "_" +
                            e1.plantNumberTo +
                            (e1.tableId !== null ? "_" + e1.tableId : "")),
                            (e1["rowNumber"] = e.rowNumber),
                            (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            (e1["executedNumberTo"] = e1.executedNumberTo),
                            (e1["vineyardOperationExecutionId"] =
                              e1.vineyardOperationDestroyingId),
                            (e1["distanceBetweenRows"] = e.distanceBetweenRows);

                          let ind =
                            _this.selected_izabrani_redovi_pom.findIndex(
                              (x) =>
                                x.id_pom ===
                                e.rowId +
                                  "_" +
                                  e1.plantNumberFrom +
                                  "_" +
                                  e1.plantNumberTo +
                                  (e1.tableId !== null ? "_" + e1.tableId : "")
                            );

                          if (ind >= 0) {
                            _this.selected_izabrani_redovi_pom.splice(ind, 1);
                          }

                          _this.selected_izabrani_redovi_pom.push(e1);
                        } else
                          (e1["id_pom"] =
                            e.rowId +
                            "_" +
                            e1.plantNumberFrom +
                            "_" +
                            e1.plantNumberTo +
                            (e1.tableId !== null ? "_" + e1.tableId : "")),
                            (e1["rowNumber"] = e.rowNumber),
                            (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            (e1["executedNumberTo"] = e1.executedNumberTo),
                            (e1["vineyardOperationExecutionId"] =
                              e1.vineyardOperationExecutionId),
                            (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                      }
                    }

                    _this.items_modal_izabrani_redovi_pom.push(e1);
                  }
                }, (e.indeterminate = false));

                // e.indeterminate = true;

                let brojPozicija = 0;

                e.positions.forEach(function (entry) {
                  let pomocniIndex2 =
                    _this.selected_izabrani_redovi_pom.findIndex(
                      (x) => x.id_pom === entry.id_pom
                    );

                  if (pomocniIndex2 > -1) brojPozicija = brojPozicija + 1;
                });

                if (brojPozicija === 0) {
                  e.indeterminate = false;
                } else if (e.positions.length === brojPozicija) {
                  e.indeterminate = false;
                  _this.selected_izabrani_redovi.push(e);
                } else {
                  e.indeterminate = true;
                  _this.selected_izabrani_redovi.push(e);
                }
              });

            _this.izracunajMere();

            if (clear) {
              _this.selected_izabrani_redovi = [];
              _this.selected_izabrani_redovi_pom = [];
            } else {
              if (
                _this.selected_izabrani_redovi_pom.length === 0 &&
                _this.ID === 0
              ) {
                _this.selected_izabrani_redovi =
                  _this.items_modal_izabrani_redovi.slice();
                _this.selected_izabrani_redovi_pom =
                  _this.items_modal_izabrani_redovi_pom.slice();
              }
            }
            this.ucitavanje = false;
            this.loading = true;
          })
          .catch((e) => {
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(this.globalServiceLocation + this.globalPort + url, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      })
                      .then((response) => {
                        _this.items_modal_izabrani_redovi = response.data;

                        _this.selected_izabrani_redovi = [];
                        // _this.selected_izabrani_redovi_pom = [];
                        _this.items_modal_izabrani_redovi_pom = [];

                        if (response.data.length > 0)
                          _this.items_modal_izabrani_redovi.forEach(function (
                            e
                          ) {
                            // e.positions.forEach(function (e1) {
                            //   if (typeof e1 === "object") {
                            //     if (_this.ID === 0) {
                            //       if (!clear)
                            //         (e1["id_pom"] =
                            //           e.rowId +
                            //           "_" +
                            //           e1.plantNumberFrom +
                            //           "_" +
                            //           e1.plantNumberTo),
                            //             (e1["rowNumber"] = e.rowNumber),
                            //           (e1["executedNumberFrom"] = e1.plantNumberFrom),
                            //           (e1["executedNumberTo"] = e1.plantNumberTo),
                            //           (e1["vineyardOperationExecutionId"] = null),
                            //           (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                            //       else
                            //         (e1["id_pom"] =
                            //           e.rowId +
                            //           "_" +
                            //           e1.plantNumberFrom +
                            //           "_" +
                            //           e1.plantNumberTo),
                            //             (e1["rowNumber"] = e.rowNumber),
                            //           (e1["executedNumberFrom"] = null),
                            //           (e1["executedNumberTo"] = null),
                            //           (e1["vineyardOperationExecutionId"] = null),
                            //           (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                            //     } else {
                            //       if (_this.ID === 0) {
                            //         let ind = _this.selected_izabrani_redovi_pom.findIndex(
                            //           (x) =>
                            //             x.id_pom ===
                            //             e.rowId +
                            //               "_" +
                            //               e1.plantNumberFrom +
                            //               "_" +
                            //               e1.plantNumberTo
                            //         );

                            //         // const result = _this.selected_izabrani_redovi_pom.find( ({ id_pom }) => id_pom === e.rowId + "_" + e1.plantNumberFrom + "_" + e1.plantNumberTo );

                            //         // if (typeof result === "object") {
                            //         if (ind >= 0) {
                            //           (e1["id_pom"] =
                            //             e.rowId +
                            //             "_" +
                            //             e1.plantNumberFrom +
                            //             "_" +
                            //             e1.plantNumberTo),
                            //             (e1["rowNumber"] = e.rowNumber),
                            //             (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            //             (e1["executedNumberTo"] = e1.executedNumberTo),
                            //             (e1["vineyardOperationExecutionId"] =
                            //               e1.vineyardOperationExecutionId),
                            //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                            //         } else
                            //           (e1["id_pom"] =
                            //             e.rowId +
                            //             "_" +
                            //             e1.plantNumberFrom +
                            //             "_" +
                            //             e1.plantNumberTo),
                            //             (e1["rowNumber"] = e.rowNumber),
                            //             (e1["executedNumberFrom"] = e1.plantNumberFrom),
                            //             (e1["executedNumberTo"] = e1.plantNumberTo),
                            //             (e1["vineyardOperationExecutionId"] = null),
                            //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                            //       } else {
                            //         if (
                            //           e1.vineyardOperationExecutionId !== null &&
                            //           _this.izmena
                            //         ) {
                            //           (e1["id_pom"] =
                            //             e.rowId +
                            //             "_" +
                            //             e1.plantNumberFrom +
                            //             "_" +
                            //             e1.plantNumberTo),
                            //             (e1["rowNumber"] = e.rowNumber),
                            //             (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            //             (e1["executedNumberTo"] = e1.executedNumberTo),
                            //             (e1["vineyardOperationExecutionId"] =
                            //               e1.vineyardOperationExecutionId),
                            //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);

                            //           _this.selected_izabrani_redovi_pom.push(e1);
                            //         } else
                            //           (e1["id_pom"] =
                            //             e.rowId +
                            //             "_" +
                            //             e1.plantNumberFrom +
                            //             "_" +
                            //             e1.plantNumberTo),
                            //             (e1["rowNumber"] = e.rowNumber),
                            //             (e1["executedNumberFrom"] = e1.executedNumberFrom),
                            //             (e1["executedNumberTo"] = e1.executedNumberTo),
                            //             (e1["vineyardOperationExecutionId"] =
                            //               e1.vineyardOperationExecutionId),
                            //             (e1["distanceBetweenRows"] = e.distanceBetweenRows);
                            //       }
                            //     }

                            //     _this.items_modal_izabrani_redovi_pom.push(e1);
                            //   }
                            // }, (e.indeterminate = false));

                            e.positions.forEach(function (e1) {
                              if (typeof e1 === "object") {
                                if (_this.ID === 0) {
                                  if (!clear)
                                    (e1["id_pom"] =
                                      e.rowId +
                                      "_" +
                                      e1.plantNumberFrom +
                                      "_" +
                                      e1.plantNumberTo +
                                      (e1.tableId !== null
                                        ? "_" + e1.tableId
                                        : "")),
                                      (e1["rowNumber"] = e.rowNumber),
                                      (e1["executedNumberFrom"] =
                                        e1.plantNumberFrom),
                                      (e1["executedNumberTo"] =
                                        e1.plantNumberTo),
                                      (e1["vineyardOperationExecutionId"] =
                                        null),
                                      (e1["distanceBetweenRows"] =
                                        e.distanceBetweenRows);
                                  else
                                    (e1["id_pom"] =
                                      e.rowId +
                                      "_" +
                                      e1.plantNumberFrom +
                                      "_" +
                                      e1.plantNumberTo +
                                      (e1.tableId !== null
                                        ? "_" + e1.tableId
                                        : "")),
                                      (e1["rowNumber"] = e.rowNumber),
                                      (e1["executedNumberFrom"] = null),
                                      (e1["executedNumberTo"] = null),
                                      (e1["vineyardOperationExecutionId"] =
                                        null),
                                      (e1["distanceBetweenRows"] =
                                        e.distanceBetweenRows);
                                } else {
                                  if (_this.ID === 0) {
                                    let ind =
                                      _this.selected_izabrani_redovi_pom.findIndex(
                                        (x) =>
                                          x.id_pom ===
                                          e.rowId +
                                            "_" +
                                            e1.plantNumberFrom +
                                            "_" +
                                            e1.plantNumberTo
                                      );

                                    if (ind >= 0) {
                                      (e1["id_pom"] =
                                        e.rowId +
                                        "_" +
                                        e1.plantNumberFrom +
                                        "_" +
                                        e1.plantNumberTo +
                                        (e1.tableId !== null
                                          ? "_" + e1.tableId
                                          : "")),
                                        (e1["rowNumber"] = e.rowNumber),
                                        (e1["executedNumberFrom"] =
                                          e1.executedNumberFrom),
                                        (e1["executedNumberTo"] =
                                          e1.executedNumberTo),
                                        (e1["vineyardOperationExecutionId"] =
                                          e1.vineyardOperationExecutionId),
                                        (e1["distanceBetweenRows"] =
                                          e.distanceBetweenRows);
                                    } else
                                      (e1["id_pom"] =
                                        e.rowId +
                                        "_" +
                                        e1.plantNumberFrom +
                                        "_" +
                                        e1.plantNumberTo +
                                        (e1.tableId !== null
                                          ? "_" + e1.tableId
                                          : "")),
                                        (e1["rowNumber"] = e.rowNumber),
                                        (e1["executedNumberFrom"] =
                                          e1.plantNumberFrom),
                                        (e1["executedNumberTo"] =
                                          e1.plantNumberTo),
                                        (e1["vineyardOperationExecutionId"] =
                                          null),
                                        (e1["distanceBetweenRows"] =
                                          e.distanceBetweenRows);
                                  } else {
                                    if (
                                      e1.vineyardOperationExecutionId !== null
                                    ) {
                                      (e1["id_pom"] =
                                        e.rowId +
                                        "_" +
                                        e1.plantNumberFrom +
                                        "_" +
                                        e1.plantNumberTo +
                                        (e1.tableId !== null
                                          ? "_" + e1.tableId
                                          : "")),
                                        (e1["rowNumber"] = e.rowNumber),
                                        (e1["executedNumberFrom"] =
                                          e1.executedNumberFrom),
                                        (e1["executedNumberTo"] =
                                          e1.executedNumberTo),
                                        (e1["vineyardOperationExecutionId"] =
                                          e1.vineyardOperationExecutionId),
                                        (e1["distanceBetweenRows"] =
                                          e.distanceBetweenRows);

                                      let ind =
                                        _this.selected_izabrani_redovi_pom.findIndex(
                                          (x) =>
                                            x.id_pom ===
                                            e.rowId +
                                              "_" +
                                              e1.plantNumberFrom +
                                              "_" +
                                              e1.plantNumberTo +
                                              (e1.tableId !== null
                                                ? "_" + e1.tableId
                                                : "")
                                        );

                                      if (ind >= 0) {
                                        _this.selected_izabrani_redovi_pom.splice(
                                          ind,
                                          1
                                        );
                                      }

                                      _this.selected_izabrani_redovi_pom.push(
                                        e1
                                      );
                                    } else if (
                                      e1.vineyardOperationDestroyingId !== null
                                    ) {
                                      (e1["id_pom"] =
                                        e.rowId +
                                        "_" +
                                        e1.plantNumberFrom +
                                        "_" +
                                        e1.plantNumberTo +
                                        (e1.tableId !== null
                                          ? "_" + e1.tableId
                                          : "")),
                                        (e1["rowNumber"] = e.rowNumber),
                                        (e1["executedNumberFrom"] =
                                          e1.executedNumberFrom),
                                        (e1["executedNumberTo"] =
                                          e1.executedNumberTo),
                                        (e1["vineyardOperationExecutionId"] =
                                          e1.vineyardOperationDestroyingId),
                                        (e1["distanceBetweenRows"] =
                                          e.distanceBetweenRows);

                                      let ind =
                                        _this.selected_izabrani_redovi_pom.findIndex(
                                          (x) =>
                                            x.id_pom ===
                                            e.rowId +
                                              "_" +
                                              e1.plantNumberFrom +
                                              "_" +
                                              e1.plantNumberTo +
                                              (e1.tableId !== null
                                                ? "_" + e1.tableId
                                                : "")
                                        );

                                      if (ind >= 0) {
                                        _this.selected_izabrani_redovi_pom.splice(
                                          ind,
                                          1
                                        );
                                      }

                                      _this.selected_izabrani_redovi_pom.push(
                                        e1
                                      );
                                    } else
                                      (e1["id_pom"] =
                                        e.rowId +
                                        "_" +
                                        e1.plantNumberFrom +
                                        "_" +
                                        e1.plantNumberTo +
                                        (e1.tableId !== null
                                          ? "_" + e1.tableId
                                          : "")),
                                        (e1["rowNumber"] = e.rowNumber),
                                        (e1["executedNumberFrom"] =
                                          e1.executedNumberFrom),
                                        (e1["executedNumberTo"] =
                                          e1.executedNumberTo),
                                        (e1["vineyardOperationExecutionId"] =
                                          e1.vineyardOperationExecutionId),
                                        (e1["distanceBetweenRows"] =
                                          e.distanceBetweenRows);
                                  }
                                }

                                _this.items_modal_izabrani_redovi_pom.push(e1);
                              }
                            }, (e.indeterminate = false));

                            // e.indeterminate = true;

                            let brojPozicija = 0;

                            e.positions.forEach(function (entry) {
                              let pomocniIndex2 =
                                _this.selected_izabrani_redovi_pom.findIndex(
                                  (x) => x.id_pom === entry.id_pom
                                );

                              if (pomocniIndex2 > -1)
                                brojPozicija = brojPozicija + 1;
                            });

                            if (brojPozicija === 0) {
                              e.indeterminate = false;
                            } else if (e.positions.length === brojPozicija) {
                              e.indeterminate = false;
                              _this.selected_izabrani_redovi.push(e);
                            } else {
                              e.indeterminate = true;
                              _this.selected_izabrani_redovi.push(e);
                            }
                          });

                        _this.izracunajMere();

                        if (clear) {
                          _this.selected_izabrani_redovi = [];
                          _this.selected_izabrani_redovi_pom = [];
                        } else {
                          if (
                            _this.selected_izabrani_redovi_pom.length === 0 &&
                            _this.ID === 0
                          ) {
                            _this.selected_izabrani_redovi =
                              _this.items_modal_izabrani_redovi.slice();
                            _this.selected_izabrani_redovi_pom =
                              _this.items_modal_izabrani_redovi_pom.slice();
                          }
                        }

                        this.ucitavanje = false;
                        this.loading = true;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    saveFrom(e) {
      e.item.executedNumberFrom = this.pomFromNew;
    },
    cancelFrom(e, parent) {
      if (
        e.item.executedNumberFrom === undefined ||
        e.item.executedNumberFrom === ""
      )
        e.item.executedNumberFrom = this.pomFromNew;
      else if (
        Number(e.item.executedNumberFrom) < Number(e.item.plantNumberFrom)
      ) {
        alert(
          "Uneta vrednost je manja od " +
            Number(e.item.plantNumberFrom) +
            " pozicije " + this.tekstBiljka1 + "."
        );
      } else if (
        Number(e.item.executedNumberFrom) > Number(e.item.plantNumberTo)
      ) {
        alert(
          "Uneta vrednost je veća od " +
            Number(e.item.plantNumberTo) +
            " pozicije " + this.tekstBiljka1 + "."
        );
      } else if (e.item.executedNumberTo !== null) {
        if (
          Number(e.item.executedNumberFrom) > Number(e.item.executedNumberTo)
        ) {
          alert(
            "Uneta vrednost je veća od " +
              Number(e.item.executedNumberTo) +
              " pozicije " + this.tekstBiljka1 + "."
          );
        } else {
          this.pomFromNew = Number(e.item.executedNumberFrom);

          let ind = this.selected_izabrani_redovi_pom.findIndex(
            (x) => x.id_pom === e.item.id_pom
          );

          if (ind >= 0) {
            this.selected_izabrani_redovi_pom.splice(ind, 1);
          }

          e.selected = true;

          if (e.item.executedNumberTo === null)
            e.item.executedNumberTo = e.item.plantNumberTo;

          this.selektovanjeParenta(e, parent);

          this.izracunajMere();
        }
      } else {
        this.pomFromNew = Number(e.item.executedNumberFrom);

        let ind = this.selected_izabrani_redovi_pom.findIndex(
          (x) => x.id_pom === e.item.id_pom
        );

        if (ind >= 0) {
          this.selected_izabrani_redovi_pom.splice(ind, 1);
        }

        e.selected = true;

        if (e.item.executedNumberTo === null)
          e.item.executedNumberTo = e.item.plantNumberTo;

        this.selektovanjeParenta(e, parent);

        this.izracunajMere();
      }
    },
    openFrom(e) {
      this.pomFromNew = e.item.executedNumberFrom;

      setTimeout(() => {
        let inputEl =
          this.$refs["kolicinaOd_" + e.item.id_pom].$el.querySelector("input");
        inputEl.select();
      }, 200);
    },
    closeFrom(e) {
      e.item.executedNumberFrom = this.pomFromNew;
    },

    saveTo(e) {
      e.item.executedNumberTo = this.pomToNew;
    },
    cancelTo(e, parent) {
      if (
        e.item.executedNumberTo === undefined ||
        e.item.executedNumberTo === ""
      )
        e.item.executedNumberTo = this.pomToNew;
      else if (
        Number(e.item.executedNumberTo) < Number(e.item.plantNumberFrom)
      ) {
        alert(
          "Uneta vrednost je manja od " +
            Number(e.item.plantNumberFrom) +
            " pozicije " + this.tekstBiljka1 + "."
        );
      } else if (
        Number(e.item.executedNumberTo) > Number(e.item.plantNumberTo)
      ) {
        alert(
          "Uneta vrednost je veća od " +
            Number(e.item.plantNumberTo) +
            " pozicije " + this.tekstBiljka1 + "."
        );
      } else if (e.item.executedNumberFrom !== null) {
        if (
          Number(e.item.executedNumberTo) < Number(e.item.executedNumberFrom)
        ) {
          alert(
            "Uneta vrednost je manja od " +
              Number(e.item.executedNumberFrom) +
              " pozicije " + this.tekstBiljka1 + "."
          );
        } else {
          this.pomToNew = Number(e.item.executedNumberTo);

          let ind = this.selected_izabrani_redovi_pom.findIndex(
            (x) => x.id_pom === e.item.id_pom
          );

          if (ind >= 0) {
            this.selected_izabrani_redovi_pom.splice(ind, 1);
          }

          e.selected = true;

          if (e.item.executedNumberFrom === null)
            e.item.executedNumberFrom = e.item.plantNumberFrom;

          this.selektovanjeParenta(e, parent);

          this.izracunajMere();
        }
      } else {
        this.pomToNew = Number(e.item.executedNumberTo);

        let ind = this.selected_izabrani_redovi_pom.findIndex(
          (x) => x.id_pom === e.item.id_pom
        );

        if (ind >= 0) {
          this.selected_izabrani_redovi_pom.splice(ind, 1);
        }

        e.selected = true;

        if (e.item.executedNumberFrom === null)
          e.item.executedNumberFrom = e.item.plantNumberFrom;

        this.selektovanjeParenta(e, parent);

        this.izracunajMere();
      }
    },
    openTo(e) {
      this.pomToNew = e.item.executedNumberTo;

      setTimeout(() => {
        let inputEl =
          this.$refs["kolicinaDo_" + e.item.id_pom].$el.querySelector("input");
        inputEl.select();
      }, 200);
    },
    closeTo(e) {
      e.item.executedNumberTo = this.pomToNew;
    },
    clearViseRedova() {
      this.items_modal_izabrani_redovi = [];
        this.selected_izabrani_redovi = [];
        this.items_modal_izabrani_redovi_pom = [];
        this.selected_izabrani_redovi_pom = [];

      if (this.item === undefined) {
        this.clear();
      } else {
        this.kolicina = this.item.quantity;
        this.secer = this.item.sugar;
        this.kiselina = this.item.acid;

        this.jm_grozdja_select = this.item.unitOfMeasure;

        if (this.item.vineyardOperationRows.length > 0) {
          this.grape_variety_select =
            this.item.vineyardOperationRows[0].grapeVariety;
        }
      }
    },
    odustani() {
      this.$refs.element3.reset();
      this.$refs.element4.reset();
      this.$refs.element5.reset();
      this.$refs.element6.reset();
      this.$refs.element7.reset();

      // this.clearViseRedova();

      this.toggleAllPom();
    },
    clear() {
      this.$refs.form1.reset();

      this.$refs.element3.reset();
      this.$refs.element4.reset();
      this.$refs.element5.reset();
      this.$refs.element6.reset();
      this.$refs.element7.reset();

      this.povrsina = 0;
      this.broj_kalemova = 0;
      this.broj_redova = 0;
      this.broj_sorti = 0;

      // this.selected_izabrani_redovi_pom = [];
    },
    dajSveTableUBloku(id_block, tabla) {
      let _this = this;
      let url = "/vineyard_table/vineyard_block?";
      if (
        this.vinery_block_select !== undefined &&
        this.vinery_block_select !== null &&
        this.vinery_block_select.length > 0
      ) {
        this.vinery_block_select.forEach(function (entry) {
          url = url + "vineyardBlockId=" + entry.id + "&";
        });
      }
      url = url.substring(0, url.length - 1);

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);
          this.vinery_table_items = response.data;

          // this.vinery_table_select = this.vinery_table_items.find(
          //   (element) => element.name === tabla
          // );

          if (_this.item !== undefined) {
            if (_this.item.vineyardOperationTables.length > 0) {
              _this.item.vineyardOperationTables.forEach(function (entry) {
                let pronadjiObj = _this.vinery_table_select.findIndex(
                  (item1) => item1.id === entry.vineyardTable.id
                );

                if (pronadjiObj < 0)
                  _this.vinery_table_select.push(entry.vineyardTable);
              });
            }
          }
          // else{
          //   let pronadjiObj1 = this.vinery_table_items.findIndex(
          //     (element) => element.name === tabla
          //   );

          // }
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(e.message);

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      // // console.log(response.data);
                      this.vinery_table_items = response.data;
                      this.vinery_table_select = this.glob_tabla;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllGrapeVariety(a) {
      this.items_modal_izabrani_redovi = [];
      this.selected_izabrani_redovi = [];

      this.grape_variety_select = undefined;
      this.grape_variety_items = [];

      let bool;
      if (a === undefined) bool = true;
      else if (a.length > 0) bool = true;
      else bool = false;

      if (this.ucitano)
        if (this.vineyardId !== undefined) {
          let _this = this;
          let url = "/vineyard/" + this.vineyardId + "/grape_varietis?";
          if (
            this.vinery_block_select !== undefined &&
            this.vinery_block_select !== null &&
            this.vinery_block_select.length > 0
          ) {
            this.vinery_block_select.forEach(function (entry) {
              url = url + "blockId=" + entry.id + "&";
            });
          }
          url = url.substring(0, url.length - 1);

          this.$http
            .get(this.globalServiceLocation + this.globalPort + url, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              _this.grape_variety_items = response.data;
              _this.dajSveTableUBloku();

              if (_this.item !== undefined && _this.item !== null) {
                let pronadjiObj = _this.grape_variety_items.findIndex(
                  (item1) =>
                    item1.id ===
                    _this.item.vineyardOperationRows[0].grapeVariety.id
                );
                _this.grape_variety_select =
                  _this.grape_variety_items[pronadjiObj];
              }

              if (
                _this.grape_variety_select !== null &&
                _this.grape_variety_select !== undefined
              ) {
                if (_this.vineyardOperationExecution.id !== undefined)
                  _this.getAllSifarnik2(false);
                else _this.getAllSifarnik2(true);
              }

              // _this.promenaVisine();
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation + this.globalPort + url,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          _this.grape_variety_items = response.data;
                          _this.dajSveTableUBloku();

                          if (_this.item !== undefined && _this.item !== null) {
                            let pronadjiObj =
                              _this.grape_variety_items.findIndex(
                                (item1) =>
                                  item1.id ===
                                  _this.item.vineyardOperationRows[0]
                                    .grapeVariety.id
                              );
                            _this.grape_variety_select =
                              _this.grape_variety_items[pronadjiObj];
                          }

                          // _this.promenaVisine();
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
    },
    getAllGrapeVarietyInit() {
      this.vinery_table_items = [];

      if (this.vineyardId !== undefined) {
        let _this = this;
        let url = "/vineyard/" + this.vineyardId + "/grape_varietis";

        this.$http
          .get(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            _this.grape_variety_items = response.data;

            _this.loadingSorte = true;

            _this.dajSveTableUBloku();
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(this.globalServiceLocation + this.globalPort + url, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      })
                      .then((response) => {
                        _this.grape_variety_items = response.data;

                        _this.loadingSorte = true;

                        _this.dajSveTableUBloku();
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    changeTabla(e) {
      if (this.vineyardId !== undefined && e !== undefined) {
        if (this.loadingSorte) {
          let _this = this;
          let url = "/vineyard/" + this.vineyardId + "/grape_varietis?";
          if (
            this.vinery_block_select !== undefined &&
            this.vinery_block_select !== null &&
            this.vinery_block_select.length > 0
          ) {
            this.vinery_block_select.forEach(function (entry) {
              url = url + "blockId=" + entry.id + "&";
            });
          }

          if (e !== undefined && e !== null && e.length > 0) {
            e.forEach(function (entry) {
              url = url + "tableId=" + entry.id + "&";
            });
          }

          url = url.substring(0, url.length - 1);

          this.$http
            .get(this.globalServiceLocation + this.globalPort + url, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              _this.grape_variety_items = response.data;

              if (this.loading) {
                if (_this.vineyardOperationExecution.id !== undefined)
                  _this.getAllSifarnik2(false);
                else _this.getAllSifarnik2(true);
              }
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation + this.globalPort + url,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          _this.grape_variety_items = response.data;

                          if (this.loading) {
                            if (
                              _this.vineyardOperationExecution.id !== undefined
                            )
                              _this.getAllSifarnik2(false);
                            else _this.getAllSifarnik2(true);
                          }
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else this.loadingSorte = true;
      }
    },
  },
  watch: {
    ID: function (val) {
      this.loading = false;
      this.loadingSorte = false;
    },
    vineyardOperationExecution: function (val) {
      this.loading = false;
      this.loadingSorte = false;
      this.clearViseRedova();
    },
    plaintObject: function (val) {
      this.loading = false;
      this.loadingSorte = false;
    },
    vineyardId: function (val) {
      this.loading = false;
      this.loadingSorte = false;

      if (val !== undefined) {
        this.getAllSifarnik();
        this.getAllJediniceMere();

        if (this.grape_variety_items.length === 0)
          this.getAllGrapeVarietyInit();
      }
    },
    item: function (val) {
      this.loading = false;
      this.loadingSorte = false;

      this.clearViseRedova();

      if (val !== undefined)
        if (val.id !== undefined) {
          this.izmena = true;

          this.id_berbe = val.id;

          this.kolicina = val.quantity;
          this.jm_grozdja_select = val.unitOfMeasure;

          if (val.vineyardOperationRows.length > 0) {
            this.grape_variety_select =
              val.vineyardOperationRows[0].grapeVariety;
          }
        } else {
          this.izmena = false;
          this.id_berbe = 0;
        }
      else {
        this.izmena = false;
        this.id_berbe = 0;
      }
      // = [];
    },
    datumOperacije: function (val) {
      // this.srediObjekat(val);
    },
    izmena_init: function (val) {
      // this.srediObjekat(val);
    },
  },
  mounted() {
    this.vinarija = daLiJeVinarija();

    if(this.vinarija){
      this.tekstBiljka = "čokota";
      this.tekstBiljka1 = "čokota";
      this.tekstBiljka2 = "Krajnji čokot";
      this.tekstBiljka3 = "kog čokota";
      this.tekstBiljka4 = "Od čokota";
      this.tekstBiljka5 = "Do čokota";
      this.tekstBiljka6 = "Niste izabrali ni jedan red u vinogradu.";
    }
    else{
      this.headers_modal_izabrani_redovi = [
      { text: "Red", value: "rowNumber", align: "center", sortable: true },
      { text: "Parcela", value: "rowNumber", align: "center", sortable: false },
      { text: "Tabla", value: "rowNumber", align: "center", sortable: false },
      { text: "Sorta", value: "rowNumber", align: "center", sortable: false },
      {
        text: "Od biljke",
        value: "plantNumberFrom",
        align: "center",
        sortable: false,
      },
      {
        text: "Do biljke",
        value: "plantNumberTo",
        align: "center",
        sortable: false,
      },
      {
        text: "Odrađeno od",
        value: "executedNumberFrom",
        align: "center",
        sortable: false,
      },
      {
        text: "Odrađeno do",
        value: "executedNumberTo",
        align: "center",
        sortable: false,
      },
      {
        text: "Broj biljaka",
        value: "",
        align: "center",
        sortable: false,
      },
    ];
    this.tekstBiljka = "biljaka";
    this.tekstBiljka1 = "biljke";
      this.tekstBiljka2 = "Krajnja biljka";
      this.tekstBiljka3 = "koje biljke";
      this.tekstBiljka4 = "Od biljke";
      this.tekstBiljka5 = "Do biljke";
      this.tekstBiljka6 = "Niste izabrali ni jedan red u zasadu.";
    }
      

    this.loading = false;
    this.loadingSorte = false;
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.v-input.v-input--selection-controls.v-input--checkbox.v-input--hide-details.v-input--is-label-active.v-input--is-dirty {
  width: 20%;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

.custom-highlight-row {
  background-color: #f3f7f4;
}
button.AppButtonFilled.v-btn.teal.lighten-2 {
  margin-left: 3px !important;
}
.gornji_text {
  font-size: 18px !important;
  margin: 0px !important;
  padding-top: 10px !important;
  text-align: center;
}

.donji_text {
  font-size: 12px !important;
  text-align: center;
  margin: 0px !important;
  line-height: 0.1 !important;
}
</style>
